<script>
  export let message = "No tiene información"
</script>

<p class="text-center fg-secondary m-0">
  · · · {message} · · ·
</p>
